import { ImageResizeMode, ImageStyle, StyleProp } from "react-native";
import { atom } from "jotai";

type ImageProps = {
    testID?: string;
    style: StyleProp<ImageStyle>[];
    resizeMode: ImageResizeMode;
};

type Image = {
    avatarPath: string | number;
    props: ImageProps;
};

type Position = {
    pageX: number;
    pageY: number;
    size: number;
};

export type EnlargeAvatarData = {
    image: Image;
    initialPosition: Position;
};

export const enlargeAvatarData = atom<EnlargeAvatarData | null>(null);
